<script>
import Loader from "@/components/widgets/loader";
/**
 * Profile component
 */
export default {
  components: {
    Loader,
  },
  data() {
    return {};
  },
  mounted() {},
  props: {
    updating: {
      type: Boolean,
    },

    doctors: {
      type: Object,
      default: () => {
        return { 
          active: 0,
          inactive: 0,
        }
      },
    },
  },
};
</script>
<template>
  <Loader :loading="updating">
    <div class="card overflow-hidden">
      <div class="bg-soft bg-primary">
        <div class="row">
          <div class="col-7">
            <div class="text-primary p-3">
              <h5 class="text-primary mb-3">Welcome Back !</h5>
            </div>
          </div>
          <div class="col-5 align-self-end">
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
          </div>
        </div>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-sm-4">
            <div class="avatar-md profile-user-wid mb-1">
              <img
                src="@/assets/images/users/avatar-7.jpg"
                alt
                class="img-thumbnail rounded-circle"
              />
            </div>
            <!-- <h5 class="font-size-15 text-truncate">admin</h5> -->
            <div class="mt-3">
              <a href class="btn btn-primary btn-sm">
                  Settings
                <i class="mdi mdi-arrow-right ms-1"></i>
              </a>
            </div>
          </div>

          <div class="col-sm-8">
            <div class="pt-4">
              <div class="row">
                <div class="col-6">
                  <h5 class="font-size-15">{{this.doctors.active}}</h5>
                  <p class="text-muted mb-0">Active <br>Doctors</p>
                </div>
                <div class="col-6">
                  <h5 class="font-size-15">{{this.doctors.inactive}}</h5>
                  <p class="text-muted mb-0">Inactive <br>Doctors</p>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
      <!-- end card-body -->
    </div>
    <!-- end card -->
  </Loader>
</template>
